/** Photo upload + render helpers. Uses managed storage; falls back gracefully to data URLs (legacy records). */
import { api } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Upload a File → returns { id, url, path, content_type }. url is relative to BACKEND. */
export async function uploadPhoto(file, purpose = "photo") {
  if (!file) throw new Error("No file");
  const form = new FormData();
  form.append("file", file);
  form.append("purpose", purpose);
  const { data } = await api.post("/files/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

/** Given a stored photo value (URL path OR legacy base64 data URL), return an absolute src.
 *  `variant`: "full" (default) or "thumb" — for storage URLs, appends ?variant=thumb. */
export function photoSrc(value, variant = "full") {
  if (!value) return "";
  if (value.startsWith("data:")) return value;                 // legacy base64
  if (value.startsWith("http://") || value.startsWith("https://")) return value;
  if (value.startsWith("/api/")) {
    const suffix = variant === "thumb" ? "?variant=thumb" : "";
    return `${BACKEND}${value}${suffix}`;
  }
  return value;
}

/** Multiple photos upload. Returns array of URL strings ready to POST to the API. */
export async function uploadPhotos(files, purpose = "claim") {
  const urls = [];
  for (const f of files) {
    // eslint-disable-next-line no-await-in-loop
    const r = await uploadPhoto(f, purpose);
    urls.push(r.url);
  }
  return urls;
}
